<div class="drawer {{ className }}" *ngIf="isOpen" [class.open]="isOpen">
	<div class="drawer-overlay"></div>

	<div class="drawer-wrapper {{ contentClassName }}">
		<div class="drawer-header px-2 py-1 d-flex align-items-center justify-content-between">
			<ng-container *ngIf="subtitle; else titleOnly">
				<div class="drawer-title-with-subtitle">
					<span class="drawer-title-text">{{ title }}</span>
					<span class="drawer-subtitle">{{ subtitle }}</span>
				</div>
			</ng-container>
			<ng-template #titleOnly>
				<span [innerHTML]="title"></span>
			</ng-template>
			<button class="btn" (click)="closeDrawer()">
				<i class="feather icon-x"></i>
			</button>
		</div>


		<hr class="m-0" />

		<div class="drawer-content px-2">
			<ng-content></ng-content>
		</div>
	</div>
</div>